import { render, staticRenderFns } from "./CmsComponent.vue?vue&type=template&id=3a1baa95"
import script from "./CmsComponent.vue?vue&type=script&lang=ts"
export * from "./CmsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports